

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';
import { IndicadoresAnalise } from '../models/indicadores-analise.model';

@Injectable({
  providedIn: 'root',
})
export class IndicadoresAnaliseService extends BaseService<IndicadoresAnalise> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public getList(id: number, obj: any[] = null): Observable<IndicadoresAnalise[]> {
    return this.http.post<IndicadoresAnalise[]>(this.baseUrl + '/' + id, obj, { headers: this.headers });
  }

  public getByListForm(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/analise-indicadores';
  }

}
